import { ShiftReportsService } from "@/modules/shiftReports/service";
import { ReadShiftReport } from "@/types/shiftReport";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export const useTimesheetShiftReportQuery = () => {
  const { shiftReportId } = useParams();
  const shiftReportQuery = useQuery<ReadShiftReport>({
    queryKey: ["shiftReport", shiftReportId],
    queryFn: () => ShiftReportsService.get(shiftReportId as string),
    enabled: !!shiftReportId,
  });

  return shiftReportQuery;
};
